import { useTranslation } from 'react-i18next';

import Button from '../../../components/buttons/Button';
import { CrownRoundedIcon } from '../../../components/SVGIcons/CrownRoundedIcon';
import { SweepCoin } from '../../../components/SweepCoin/SweepCoin';
import { useLocale } from '../../../hooks/useLocale';
import styles from '../Onboarding.module.scss';

export const SweepCoinTooltip = (props: { handleClick: VoidFunction }) => {
  const { t } = useTranslation();
  const { isGDPR } = useLocale();
  const sweepsPolicyUrl = isGDPR ? t('sweeps.policy.superUrl') : t('sweeps.policy.url');

  return (
    <>
      <p>
        <span>{t('onboarding.playWith')}</span>
        <span className={styles.coinImage}>
          <CrownRoundedIcon />
          <SweepCoin />
        </span>
        <strong>{t('sweeps.cash', { sweepsOrSuper: !isGDPR })} </strong>
        <span>{t('onboarding.redeemWinnings')} </span>
        <a className={styles.sweepsPolicyLink} href={`/pages/${sweepsPolicyUrl}`} rel="noreferrer" target="_blank">
          {t('sweepstakes.rules', { sweepstakesOrSuper: !isGDPR })}
        </a>
      </p>
      <Button btnType="main" onClick={props.handleClick}>
        {t('onboarding.awesome')}
      </Button>
    </>
  );
};
